module.exports = __webpack_public_path__ + "media/images/icons/country_flags/au-8cc9433039670f61e180c9836062dbc2.svg";